import warning from '../../../assets/warning.svg'
import styles from './priceinfo.module.scss'

const CreditWarning = () => {
  return (
    <div className={styles.warningBox}>
      <div className={styles.warningTriangle}>
        <img src={warning} alt="warning-triangle" />
      </div>
      <p className={styles.warningText}>
        <strong>Att låna kostar pengar!</strong>
        <br />
        Om du inte kan betala tillbaka skulden i tid riskerar du en
        betalningsanmärkning. Det kan leda till svårigheter att få hyra bostad,
        teckna abonnemang och få nya lån. För stöd, vänd dig till budget- och
        skuldrådgivningen i din kommun. Kontaktuppgifter finns på{' '}
        <a
          href="https://www.konsumentverket.se/"
          title="Länk till extern webbplats, öppnas i ett nytt fönster."
          target="_blank"
          rel="noreferrer"
        >
          konsumentverket.se
        </a>
        .
      </p>
    </div>
  )
}

export default CreditWarning
